import axios from 'axios';
import { useEffect, useState } from 'react';
import { Card, Col, Row, Table, Carousel } from 'react-bootstrap';
import { formatCurrency, getCurrentFiscalYear } from './Util';


export default function Dashboard() {

    const VISITATION_BASE_URL = process.env.REACT_APP_VISITATION_BASE_URL;
    const VISITATION_SEARCH = process.env.REACT_APP_VISITATION_SEARCH;

    const visitors_data = [
        ["Total Visitation", "Total Paid", "Total UnPaid"],
        ["$12,430", "$8,765", "$3,665"]
    ];

    const imageInterval = 20000;
    const images1 = [
        './img/p1.JPG',
        './img/p2.JPG',
        './img/p3.JPG',

        './img/p5.JPG',
        './img/p6.JPG',
        './img/p7.JPG',
    ];

    const images2 = [
        // './img/p11.jpg',
        './img/p12.jpg',
        './img/p13.jpg',
        './img/p14.jpg',
        './img/p15.jpg',
        './img/p16.jpg',
        './img/p17.jpg',

    ];
    const [visitationResponse, setVisitationResponse] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const visitationData = {
                    siteName: "",
                    year: "",
                    month: "",
                    status: "APPROVED"
                }
                //Use Promise.all to make API's run parallel
                const [visitationResult] = await axios.post(VISITATION_BASE_URL + VISITATION_SEARCH, visitationData);
                const data = visitationResult.data;
                setVisitationResponse(data);
                getTotalPaid(data);
            } catch (error) {
                console.error(error);
            }

        };
        // Call the async function
        fetchData();
    }, []);


    const tableData = visitationResponse && visitationResponse.map(item => [item.siteName, item.year, item.month, item.status, item.type]);
    const [visitMap, setVisitMap] = useState(new Map());
    const getTotalPaid = (visitationData) => {

        const currentFiscalyear = getCurrentFiscalYear();
        console.log(`Fiscal Year : ${currentFiscalyear}`);
        const currentFiscalData = visitationData.filter((entry) => entry.fiscalYear === currentFiscalyear);
        // const currentFiscalData = visitationData;
        const data = currentFiscalData.reduce((acc, record) => {

            const total = parseFloat(record.visitation.totalVisitation) || 0;
            const paid = parseFloat(record.visitation.paid.generalVisitors) || 0;
            const unpaid = parseFloat(record.visitation.unpaid.otherNonTicketed) || 0;

            acc.set('generalTotal', (acc.get('generalTotal') || 0) + total);
            acc.set('generalPaid', (acc.get('generalPaid') || 0) + paid);
            acc.set('generalUnpaid', (acc.get('generalUnpaid') || 0) + unpaid);

            const eventTotal = parseFloat(record.eventsAdmissions.totalEventRevenue) || 0;
            const eventPaid = parseFloat(record.eventsAdmissions.visitorsPaid) || 0;
            const eventUnpaid = parseFloat(record.eventsAdmissions.visitorsUnPaid) || 0;

            acc.set('eventTotal', (acc.get('eventTotal') || 0) + eventTotal);
            acc.set('eventPaid', (acc.get('eventPaid') || 0) + eventPaid);
            acc.set('eventUnpaid', (acc.get('eventUnpaid') || 0) + eventUnpaid);

            const outreachPaid = parseFloat(record.visitation.paid.paidOutreachOffsiteVirtual) || 0;
            const outreachUnpaid = parseFloat(record.visitation.unpaid.outreachOffsiteVirtual) || 0;
            const outreachTotal = parseFloat(outreachPaid + outreachUnpaid) || 0;

            acc.set('outreachTotal', (acc.get('outreachTotal') || 0) + outreachTotal);
            acc.set('outreachPaid', (acc.get('outreachPaid') || 0) + outreachPaid);
            acc.set('outreachUnpaid', (acc.get('outreachUnpaid') || 0) + outreachUnpaid);

            const revenuePhmcShare = parseFloat(record.revenue.phmcAdmissionShare) || 0;
            const revenueAssociateShare = parseFloat(record.revenue.associateAdmissionShare) || 0;
            const revenueTotal = parseFloat(record.revenue.totalAdmissionsRevenue) || 0;

            acc.set('revenueTotal', (acc.get('revenueTotal') || 0) + revenueTotal);
            acc.set('revenuePhmcShare', (acc.get('revenuePhmcShare') || 0) + revenuePhmcShare);
            acc.set('revenueAssociateShare', (acc.get('revenueAssociateShare') || 0) + revenueAssociateShare);

            // PerformancePoints data
            const schoolVisitors = parseFloat(record.visitation.paid.schoolVisitors) || 0;
            const outOfState = parseFloat(record.visitation.paid.outOfStateVisitors) || 0;


            acc.set('schoolVisitors', (acc.get('schoolVisitors') || 0) + schoolVisitors);
            acc.set('outOfState', (acc.get('outOfState') || 0) + outOfState);


            return acc;
        }, new Map());

        setVisitMap(data);
    }


    const GeneralVisitor = ({ visitMap }) => {
        const total = visitMap.get('generalTotal') || 0;
        const paid = visitMap.get('generalPaid') || 0;
        const unpaid = visitMap.get('generalUnpaid') || 0;

        return (
            <Table borderless>
                <thead>
                    <th>Total</th>
                    <th>Paid</th>
                    <th>Unpaid</th>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{total}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{paid}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{unpaid}</td>
                    </tr>
                </tbody>
            </Table>

        );
    }
    const EventsAdmissions = ({ visitMap }) => {
        const total = visitMap.get('eventTotal') || 0;
        const paid = visitMap.get('eventPaid') || 0;
        const unpaid = visitMap.get('eventUnpaid') || 0;

        return (
            <Table borderless>
                <thead>
                    <th>Total</th>
                    <th>Paid</th>
                    <th>Unpaid</th>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{formatCurrency(total)}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{paid}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{unpaid}</td>
                    </tr>
                </tbody>
            </Table>

        );
    }

    const Outreach = ({ visitMap }) => {
        const total = visitMap.get('outreachTotal') || 0;
        const paid = visitMap.get('outreachPaid') || 0;
        const unpaid = visitMap.get('outreachUnpaid') || 0;

        return (
            <Table borderless>
                <thead>
                    <th>Total</th>
                    <th>Paid</th>
                    <th>Unpaid</th>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{total}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{paid}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{unpaid}</td>
                    </tr>
                </tbody>
            </Table>

        );
    }

    const AdmissionsRevenue = ({ visitMap }) => {
        const total = visitMap.get('revenueTotal') || 0;
        const paid = visitMap.get('revenuePhmcShare') || 0;
        const unpaid = visitMap.get('revenueAssociateShare') || 0;

        return (
            <Table borderless>
                <thead>
                    <th>Total</th>
                    <th>PHMC Share</th>
                    <th>Associate Share</th>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{formatCurrency(total)}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{formatCurrency(paid)}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{formatCurrency(unpaid)}</td>
                    </tr>
                </tbody>
            </Table>

        );
    }

    const RentalRevenue = ({ visitMap }) => {
        return (
            <Table borderless>
                <thead>
                    <th>Total</th>
                    <th>PHMC Share</th>
                    <th>Associate Share</th>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{formatCurrency(20231)}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{formatCurrency(20231)}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{formatCurrency(20231)}</td>

                    </tr>
                </tbody>
            </Table>
        );
    }
    const PerformancePoints = ({ visitMap }) => {
        const schoolVisitors = visitMap.get('schoolVisitors') || 0;
        const outOfState = visitMap.get('outOfState') || 0;

        return (
            <Table bordered>
                <thead bordered>
                    <th>School Visitors</th>
                    <th>Out-of-State Visitors</th>
                    <th>Members </th>
                    <th>Volunteer Hours</th>
                    <th>Funds Raised</th>
                </thead>
                <tbody >
                    <tr>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{schoolVisitors}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{outOfState}</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>31</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>432</td>
                        <td style={{ fontSize: '100%', fontWeight: 'bold' }}>{formatCurrency(20231)}</td>
                    </tr>
                </tbody>
            </Table>

        );
    }

    return (
        <>
            <div >
                <p className='dashboard'>PHMC Dashboard</p>
            </div >
            <br />
            <Carousel data-bs-theme="light">
                <Carousel.Item interval={imageInterval}>
                    <Card>

                        <Card.Body>
                            <Card.Title>General Admissions</Card.Title> <br />
                            <GeneralVisitor visitMap={visitMap} />
                        </Card.Body>
                    </Card>
                </Carousel.Item>
                <Carousel.Item interval={imageInterval}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Event Admissions</Card.Title> <br />
                            <Card.Text>
                                <EventsAdmissions visitMap={visitMap} />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Carousel.Item>
                <Carousel.Item interval={imageInterval}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Outreach Participants</Card.Title> <br />
                            <Card.Text>
                                <Outreach visitMap={visitMap} />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Carousel.Item>
            </Carousel>
            <Row xs={1} md={2} className="g-4">
                <Col >
                    <Carousel data-bs-theme="light">
                        {images1.map((image, index) => (
                            <Carousel.Item interval={imageInterval} key={index}>
                                <Card>
                                    <div className="item-container">
                                    </div>
                                    <Card.Img variant="top" src={image} aria-label='site image' />
                                </Card>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </Col>
                <Col >
                    <Carousel data-bs-theme="light">
                        {images2.map((image, index) => (
                            <Carousel.Item interval={imageInterval} key={index}>
                                <Card>
                                    <Card.Img variant="top" src={image} aria-label='site image' />
                                </Card>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </Col>

            </Row>
            <br />

            <br />
            <Row xs={1} md={3} className="g-4">

                <Col >
                    <Card>

                        <Card.Body>
                            <Card.Title>General Admissions Revenue</Card.Title> <br />
                            <AdmissionsRevenue visitMap={visitMap} />
                        </Card.Body>
                    </Card>
                </Col>
                <Col >
                    <Card>

                        <Card.Body>
                            <Card.Title>Rental Revenue</Card.Title> <br />
                            <Card.Text>
                                <RentalRevenue visitMap={visitMap} />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col >
                    <Card>

                        <Card.Body>
                            <Card.Title>Performance Points</Card.Title>
                            <br />
                            <Card.Text>
                                <PerformancePoints visitMap={visitMap} />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>


            </Row>
            <br />


        </>
    );
}